module.exports = __webpack_public_path__ + "img/logo_vipcard_white@2x.d635e0dd.png";